// extracted by mini-css-extract-plugin
module.exports = {"form":"search-form_form__nsuEb","button":"search-form_button__hDzr_"};